(() => {
  const norm = (s) => (s || "").toLowerCase().trim();

  function getVariantIdFromForm() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input?.value?.trim() || "";
  }

  async function getSelectedColor(variantId) {
    if (!variantId) return "";
    const res = await fetch(`/variants/${variantId}.js`, { credentials: "same-origin" });
    if (!res.ok) return "";
    const data = await res.json();
    return data?.option1 || "";
  }

  function extractColorFromAlt(alt) {
    const a = norm(alt);
    if (!a.startsWith("color:")) return null;

    // Extract text after "Color:"
    const afterPrefix = a.replace("color:", "").trim();

    // If you include " - Front", remove the suffix
    return afterPrefix.split("-")[0].trim();
  }

  function matchesSelected(alt, selectedColor) {
    const a = norm(alt);
    const c = norm(selectedColor);

    if (!a) return true; // Blank alt = shared media

    const altColor = extractColorFromAlt(a);

    if (altColor) {
      return altColor === c;
    }

    return true; // No Color: prefix = shared media
  }

  function filterGallery(selectedColor) {
    if (!selectedColor) return;

    const mediaItems = Array.from(document.querySelectorAll(".product__media-item"));
    const thumbs = Array.from(document.querySelectorAll(".thumbnail-list__item"));

    mediaItems.forEach((item) => {
      const img = item.querySelector("img");
      const alt = img ? img.getAttribute("alt") : "";
      item.style.display = matchesSelected(alt, selectedColor) ? "" : "none";
    });

    thumbs.forEach((thumb) => {
      const btn = thumb.querySelector("button");
      const target =
        btn?.getAttribute("data-target") ||
        btn?.getAttribute("aria-controls") ||
        thumb.getAttribute("data-target") ||
        "";

      const id = String(target).match(/\d+/)?.[0];
      if (!id) return;

      const mediaItem = document.querySelector(`.product__media-item[data-media-id="${id}"]`);
      if (!mediaItem) return;

      thumb.style.display = mediaItem.style.display === "none" ? "none" : "";
    });
  }

  async function applyFilter() {
    const variantId = getVariantIdFromForm();
    const color = await getSelectedColor(variantId);

    filterGallery(color);
    setTimeout(() => filterGallery(color), 100);
    setTimeout(() => filterGallery(color), 300);
  }

  function watchVariantChanges() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!input) return;

    let last = input.value;

    const obs = new MutationObserver(() => {
      const now = input.value;
      if (now && now !== last) {
        last = now;
        applyFilter();
      }
    });

    obs.observe(input, { attributes: true, attributeFilter: ["value"] });

    document.addEventListener("change", (e) => {
      if (e.target.closest("variant-selects") || e.target.closest("variant-radios")) {
        setTimeout(() => {
          const now = input.value;
          if (now && now !== last) {
            last = now;
            applyFilter();
          }
        }, 50);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    applyFilter();
    watchVariantChanges();
  });
})();